/** @jsx jsx */
import React, { useState, useEffect } from 'react';
import { css, jsx } from '@compiled/react';
import { HorizontalBarChart } from '@atlassian/viz-platform-charts--next/charts';
import { element, useElementProps } from '@atlassian/viz-platform-charts--next/core';

const chartStyles = css({
	display: 'flex',
	minWidth: '0',
	minHeight: '0',
	transition: 'opacity .3s ease-in-out',
	aspectRatio: '4 / 3',
});

// Source https://bitbucket.org/atlassian/atlassian-visualization/src/main/src/primitives/container/layout.tsx
export const CustomLayout = element(
	() => {
		const { children, width, height } = useElementProps(HorizontalBarChart.elements.Layout);

		const [fadeInOpacity, setFadeInOpacity] = useState(0);
		useEffect(() => {
			let isMounted = true;

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			const ref = window.requestAnimationFrame(() => {
				// TODO: would be nice to fade in without triggering another render
				if (isMounted) setFadeInOpacity(1);
			});
			return () => {
				isMounted = false;

				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				window.cancelAnimationFrame(ref);
			};
		}, [setFadeInOpacity]);

		return (
			<>
				<div
					data-element="layout"
					// eslint-disable-next-line jira/react/no-style-attribute
					style={{
						width,
						height,
					}}
				>
					<div
						data-element="chart"
						// eslint-disable-next-line jira/react/no-style-attribute
						style={{
							opacity: fadeInOpacity,
						}}
						css={chartStyles}
					>
						{children}
					</div>
				</div>
			</>
		);
	},
	{ as: HorizontalBarChart.elements.Layout },
);
